import React, { useState } from 'react';
import './Footer.css';

import logo from "../../../assets/logo.png";

import { FaFacebookSquare } from 'react-icons/fa';
import { FaInstagramSquare } from 'react-icons/fa';
import { FaTwitterSquare } from 'react-icons/fa';
import { IoLogoYoutube } from 'react-icons/io';
import { NavLink } from 'react-bootstrap';

const Footer = () => {
    const [subscribeEmail, setSubscribeEmail] = useState("");
    return (
        <footer fixed="bottom" className="text-center text-white pt-5 pb-3 py-md-3" style={{ backgroundColor: "rgb(2 29 42)" }}>
            <div className="row gx-0 d-flex justify-content-around align-items-center py-md-5">
                <div className="col-12 col-md-12 d-flex justify-content-around align-items-center">
                    <div className="row gx-0 d-flex justify-content-between align-items-start">
                        <div className="col-12 col-md-4 my-auto">
                            <img src={logo} alt="logo" className="img-fluid w-75" />
                            <div className="d-flex justify-content-around align-items-center mx-auto w-50 fw-bold mt-md-3 py-2">
                                <a target="_blank" href="https://www.facebook.com/profile.php?id=100085651569310"><FaFacebookSquare className="fs-3" style={{ color: "#F7EA80" }} /></a>
                                <FaInstagramSquare className="fs-3" style={{ color: "#F7EA80" }} />
                                <FaTwitterSquare className="fs-3" style={{ color: "#F7EA80" }} />
                                <IoLogoYoutube className="fs-3" style={{ color: "#F7EA80" }} />
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="footer-nav botom_nav">
                                <ul className="d-flex justify-content-center align-items-center">
                                    <li><NavLink href="/menu">Menu</NavLink></li>
                                    <li><NavLink href="/reservation">Restauration</NavLink></li>
                                    <li><NavLink href="/reservation">Réservation</NavLink></li>
                                    <li><NavLink href="/about">À Propos De</NavLink></li>
                                </ul>
                            </div>
                            <div className="text-white text-center">
                                <h5 className="fw-bold" style={{ color: "#ffdea0" }}>Nous Contacter</h5>
                                <address>LE SONARGA Restaurant & Gastronomie,124 Rue Jean Adoué 31800 Saint-Gaudens, France <span className='number_mediaqr'>05 67 48 47 33</span></address>
                                <p>E-mail: <a className='text-decoration-none text-white' href="mailto:info@le-sonarga.com">info@le-sonarga.com</a></p>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 d-flex flex-column justify-content-around align-items-center big_fonts_opti my-auto">
                            <h4 className="text-uppercase">ABONNEZ-VOUS AUX NOUVELLES</h4>
                            <div className="input-group my-3 w-75">
                                <input id="footer-subscribe-input" onChange={(e) => setSubscribeEmail(e.target.value)} value={subscribeEmail} type="email" className="form-control" placeholder="Email" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                                <span onClick={() => setSubscribeEmail("")} className="input-group-text footer-subscribe" id="footer-subscribe-button">S'abonner</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                                <img src="https://betkingly.com/static/media/visa.e7dd172cd4109bc988c2.png" alt="visa" className="img-fluid mx-2" width="30px" />
                                <img src="https://betkingly.com/static/media/maestro.537cc04234db6941117d.png" alt="master" className="img-fluid mx-2" width="30px" />
                                <img src="https://betkingly.com/static/media/paypal.17f643efbd8506e667ee.png" alt="paypal" className="img-fluid mx-2" width="30px" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div className="row gx-0 d-flex justify-content-around align-items-center">
                <div className="col-12 text-center d-flex justify-content-center align-items-center">
                    <small>&copy; <span className="fw-bold">LE-SONARGA</span> {new Date().getFullYear()}</small>
                </div>
            </div>
        </footer>
    );
};

export default Footer;